import script from "./JourneyLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./JourneyLayout.vue?vue&type=script&setup=true&lang=js"

import "./JourneyLayout.vue?vue&type=style&index=0&id=86fbe05a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86fbe05a"]])

export default __exports__